<template>
  <div>
    <el-tag
      v-for="tag in value"
      :key="tag"
      closable
      :disable-transitions="false"
      @close="handleClose(tag)"
      class="mr-1 mb-1"
    >
      {{ tag }}
    </el-tag>
    <el-input
      v-if="inputVisible"
      ref="InputRef"
      v-model="inputValue"
      class="w-20"
      size="small"
      @keyup.native.enter="handleInputConfirm"
      @blur="handleInputConfirm"
    />
    <el-button
      v-else
      class="mt-2"
      size="small"
      @click="showInput"
    >
      {{ addTagText }}
    </el-button>
  </div>
</template>

<script>
export default {
  name: "SmartTag",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    addTagText: {
      type: String,
      default: "+ New Tag"
    },
  },
  data() {
    return {
      inputVisible: false,
      inputValue: "",
    };
  },
  methods: {
    handleClose(tag) {
      const tags = this.value.filter((t) => t !== tag);
      this.$emit("input", tags);
      this.$emit("change", tags);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.InputRef && this.$refs.InputRef.focus();
      });
    },
    handleInputConfirm() {
      console.log("handleInputConfirm", this.inputValue);
      let inputValue = this.inputValue;
      if (inputValue && !this.value.includes(inputValue)) {
        const tags = [...this.value, inputValue];
        this.$emit("input", tags);
        this.$emit("change", tags);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>
